import { render, staticRenderFns } from "./Modify-Password.vue?vue&type=template&id=16a07272&scoped=true"
import script from "./Modify-Password.vue?vue&type=script&lang=js"
export * from "./Modify-Password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a07272",
  null
  
)

export default component.exports